import React from "react";
import PrescriptionDetailComponent from "@components/User/Prescription/PrescriptionDetail/PrescriptionDetail";

export default function PrescriptionDetail() {
  return <PrescriptionDetailComponent />;
}
